import { render, staticRenderFns } from "./RecordingIndicator.vue?vue&type=template&id=4630564c&"
import script from "./RecordingIndicator.vue?vue&type=script&lang=js&"
export * from "./RecordingIndicator.vue?vue&type=script&lang=js&"
import style0 from "./RecordingIndicator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VFlex,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4630564c')) {
      api.createRecord('4630564c', component.options)
    } else {
      api.reload('4630564c', component.options)
    }
    module.hot.accept("./RecordingIndicator.vue?vue&type=template&id=4630564c&", function () {
      api.rerender('4630564c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Recording/RecordingIndicator.vue"
export default component.exports